import React from "react";
import { Container, Row, Col } from "reactstrap";

// Import Breadcrumb
import Breadcrumbs from '../../../components/Common/Breadcrumb';

// Import Components
import StudentProfileCard from "./ProfileCard";
import StudentCalender from "./Calender";
import StaffAttendance from "./Attendance";
import DashboardTaskList from "./TaskList";

const StaffDashboard = () => {
    const breadcrumbItems = [
        { title: "Brandstrek", link: "/" },
        { title: "Dashboard", link: "#" },
    ];



    return (

        <div className="page-content ">
            <Container fluid>
                <Breadcrumbs title="Dashboard" breadcrumbItems={breadcrumbItems} />

                <Row>
                    <Col xl={4}>

                        < StudentProfileCard />
                        <StaffAttendance />
                        {/* <ParentTodoList /> */}
                        {/* <DashboardTaskList limit={3} /> */}

                    </Col>
                    <Col xl={4}>

                        {/* < StudentProfileCard /> */}
                        {/* <StaffAttendance /> */}
                        {/* <ParentTodoList /> */}
                        <DashboardTaskList limit={3} />

                    </Col>
                    {/* <Col xl={8}>
                        <Row> */}
                    {/* <StudTimeline /> */}

                    {/* <StaffAttendance /> */}
                    {/* </Row>
                    </Col> */}
                </Row>



                <Row>
                    {/* Latest Transactions */}
                    <StudentCalender />
                </Row>
            </Container>
        </div>
    );
};

export default StaffDashboard;
